<template>
  <div class="article-frame sup-page-frame">
    <div class="article-box sup-page-box">
      <img class="header-img" :src="$getThemeImagePath('sup/sub_support_banner.png')">
      <div class="content pos-relative">
        <go-to-top />
        <div class="sup-grid-wrap">
          <a class="sup-grid-item" @click="$router.push('/page/sup-how-to-register')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_1.png')" alt="登録方法">
            <p class="sup-grid-label">
              登録方法
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-how-to-login')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_2.png')" alt="ログイン方法">
            <p class="sup-grid-label">
              ログイン方法
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-verify-your-account')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_3.png')" alt="KYC認証（本人確認）方法">
            <p class="sup-grid-label">
              KYC認証（本人確認）方法
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-wallet')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_4.png')" alt="ウォレットについて">
            <p class="sup-grid-label">
              ウォレットについて
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-payment-method')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_5.png')" alt="入出金方法">
            <p class="sup-grid-label">
              入出金方法
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-cardsetting-bank')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_6.png')" alt="出金口座の登録方法">
            <p class="sup-grid-label">
              出金口座の登録方法
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-vip-class-upgrading')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_7.png')" alt="ショップについて">
            <p class="sup-grid-label">
              ショップについて
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-faq')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_8.png')" alt="よくある質問">
            <p class="sup-grid-label">
              よくある質問
            </p>
          </a>
          <a class="sup-grid-item" @click="$router.push('/page/sup-self-restraint')">
            <img class="sup-grid-icon" :src="$getThemeImagePath('sup/sub_support_9.png')" alt="自己制限">
            <p class="sup-grid-label">
              自己制限
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'Support',
  components: {
    goToTop
  },
  data() {
    return {

    }
  },
  computed: {

  },
  created() {

  },
  methods: {

  }
}
</script>
